// extracted by mini-css-extract-plugin
export var chevron = "_lc-2";
export var chevronRotated = "_lc-3";
export var header = "_lc-1";
export var section = "_lc-0";